import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import ContentButton from "../../../../General/components/ContentButton/ContentButton";
import WhatsAppIcon from "./WhatsAppIcon";
import SMSIcon from "./SMSIcon";
import s from "./ServiceIcon.pcss";

const ServiceIcon = ({name, active, onClick, ariaLabel, ...rest}) => {
    const Icon = name === "sms" ? SMSIcon : WhatsAppIcon;
    return (
        <ContentButton aria-label={ariaLabel} onClick={onClick} {...rest}>
            <Icon
                active={active}
                width={45}
                height={45}
                className={s.logo}
                {...rest}
                tabIndex={-1}
            />
        </ContentButton>
    );
};

ServiceIcon.propTypes = {
    name: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    active: PropTypes.bool,
    onClick: PropTypes.func,
};

ServiceIcon.defaultProps = {
    active: false,
    onClick: noop,
};

export default ServiceIcon;
